import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import Level from '@/ui/components/common/Level.vue';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { SecondaryNavbar, TabItem } from '@/ui/components/navigation/SecondaryNavbar';
  import { TrainingsTabNames, queryTabName } from '@/ui/components/navigation/constants';
  import * as qs from '@/ui/queryState';
  import ManageCoursesTab from '@/ui/pages/trainings/tabs/ManageCoursesTab.vue';
  import TakeCourseTab from '@/ui/pages/trainings/tabs/TakeCourseTab.vue';
  import CompletedCoursesTab from '@/ui/pages/trainings/tabs/CompletedCoursesTab.vue';
  //todo check permissions for this button
  import CreateCourseButton from '@/ui/components/trainings/courses/CreateCourseButton.vue';
  import { t } from '@/ui/i18n/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingPage',
  setup(__props) {

  const activeTab = qs.stringEnum<TrainingsTabNames>(
    queryTabName,
    Object.values(TrainingsTabNames),
    TrainingsTabNames.MANAGE,
    false,
  );

  const secondaryTabItems: TabItem[] = [
    {
      value: TrainingsTabNames.MANAGE,
      label: t('trainings.manage'),
      tooltipLabel: t('trainings.manage-hint'),
      icon: 'book',
      underLineColor: 'blue',
    },
    {
      value: TrainingsTabNames.TAKE,
      label: t('trainings.take'),
      tooltipLabel: t('trainings.take-hint'),
      icon: 'book-open',
      underLineColor: 'blue',
    },
    {
      value: TrainingsTabNames.ASSIGNED,
      label: t('trainings.assigned'),
      tooltipLabel: t('trainings.assigned-hint'),
      icon: 'calendar-alt',
      underLineColor: 'blue',
    },
    {
      value: TrainingsTabNames.COMPLETED,
      label: t('trainings.completed'),
      tooltipLabel: t('trainings.completed-hint'),
      icon: 'trophy',
      underLineColor: 'blue',
    },
  ];

  const setActiveTab = (tab: TrainingsTabNames) => {
    activeTab.value = tab;
  };

  const tabs = {
    [TrainingsTabNames.MANAGE]: ManageCoursesTab,
    [TrainingsTabNames.TAKE]: TakeCourseTab,
    // [TrainingsTabNames.ASSIGNED]: AssignedCoursesTab,
    [TrainingsTabNames.COMPLETED]: CompletedCoursesTab,
  };

  const currentTab = computed(() => tabs[activeTab.value]);

return { __sfc: true,activeTab, secondaryTabItems, setActiveTab, tabs, currentTab, Level, PageTitle, SecondaryNavbar, TrainingsTabNames, CreateCourseButton }
}

})